/* CustomFieldsRenderer.js */

"use strict";

const _ = require("lodash");

class CustomFieldsRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("custom-field-column");
        this._rootElem.component = this._model;

        this._checkboxIcon = undefined;
        this._renderContainer = undefined;

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._checkboxIcon = undefined;
            this._renderContainer = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._model.on("Value", (this._onValue = this._onValue.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("Value");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setValue(this._model.getValue());
            resolve();
        });
        return prom;
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _setValue(newVal) {
        this._rootElem.innerHTML = "";
        this._renderContainer = document.createElement("div");
        if (newVal === true) {
            this._checkboxIcon = document.createElement("base-icon-gl");
            this._checkboxIcon.dataset.icon = "common.check";
            this._renderContainer.appendChild(this._checkboxIcon);
        } else if (_.isNumber(newVal)) {
            this._renderContainer.innerText = !newVal && newVal !== 0 ? "" : newVal;
        } else if (_.isArray(newVal)) {
            this._renderContainer.innerText = newVal.join(", ");
        } else {
            this._renderContainer.innerText = newVal ? newVal : "";
        }

        this._rootElem.appendChild(this._renderContainer);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _onValue(newVal) {
        this._setValue(newVal);
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = CustomFieldsRenderer;
